import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { FormEvent, useState } from 'react'
import { useLoginNonResidentMutation } from 'services/auth/nonResident'
import { useNavigate } from 'react-router-dom'
import { useLogoutMutation } from 'services/auth/logout'
import ReCAPTCHA from 'react-google-recaptcha'
import useRecaptcha from './useRecaptcha'
import { toast } from 'react-toastify'

interface Props {
  open: boolean
  onClose: () => void
}

export function NonResidentLoginDialog({ open, onClose }: Props) {
  const { t } = useTranslation()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const { capchaToken, recaptchaRef, handleRecaptcha } = useRecaptcha()
  const navigate = useNavigate()
  const [loginNonResident, { isLoading: isLoginLoading, error }] =
    useLoginNonResidentMutation()
  const [logout] = useLogoutMutation()

  const credentialsWrong = error && 'status' in error && error.status === 404

  async function submitForm(e: FormEvent) {
    e.preventDefault()
    if (!capchaToken) {
      toast.error(t('recaptcha-error'))
    } else {
      await logout()
      await loginNonResident({
        username,
        password,
        recaptchaResponse: capchaToken,
      }).then((d) => {
        if (!('error' in d)) {
          navigate('/portal')
        }
      })
    }
    recaptchaRef.current?.reset()
  }

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: 'bold' }}>
        {t('non-resident-login_foreigner')}
      </DialogTitle>

      <DialogContent sx={{ py: 3, my: 3 }}>
        <form
          onSubmit={submitForm}
          action="javascript:alert(grecaptcha.getResponse(widgetId1));"
        >
          <Box
            mb={2}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey="6LcoWOErAAAAAK3PfhPKggodKsPdG-ljcLYXAgzQ"
              onChange={handleRecaptcha}
            />
          </Box>
          <Grid container>
            <Grid item xs={12}>
              <label style={{ flexShrink: 1, whiteSpace: 'nowrap' }}>
                {t('username_foreigner')}
              </label>
              <TextField
                fullWidth
                size="small"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </Grid>
          </Grid>

          <Grid container sx={{ mt: 2 }}>
            <Grid item xs={12}>
              <label style={{ flexShrink: 1, whiteSpace: 'nowrap' }}>
                {t('password_foreigner')}
              </label>
              <TextField
                fullWidth
                size="small"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Grid>
          </Grid>

          {credentialsWrong && (
            <Box mt={2}>
              <Typography color="error">
                {t('wrong-credentials_foreigner')}
              </Typography>
            </Box>
          )}

          <Box display="flex" mt={2} justifyContent="flex-end" alignItems="center">
            <Button disabled={isLoginLoading} onClick={onClose} variant="outlined">
              {t('back_foreigner')}
            </Button>
            <Button
              type="submit"
              // onSubmit={submitForm}
              disabled={!username || !password || isLoginLoading || !capchaToken}
              sx={{ ml: 1.5 }}
              variant="contained"
              style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
            >
              {t('login_foreigner')}
            </Button>
          </Box>
        </form>
      </DialogContent>
    </Dialog>
  )
}
